import { useQuery } from '@maui/react-query'
import { useMatiApiClient } from './client'
import { normalizeFileReport } from '../../adapters'

export const useFileReport = (hash, options = {}) => {
  if (!hash) {
    throw new Error('useFileReport requires a hash')
  }
  const api = useMatiApiClient('files')
  return useQuery({
    queryFn: () => {
      return api.fetchFileReport(hash).then(data => {
        return normalizeFileReport(data)
      })
    },
    queryKey: ['files/report', hash],
    ...options
  })
}
